import * as React from 'react';
import { get } from 'lodash';
import { Model, Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { Box } from '@material-ui/core';
import { InfoTooltip } from '../InfoTooltip';
import { ResponsiveTextField } from '../ResponsiveTextField';
import { RefObject } from 'react';

export const TYPE = 'mui-text';

export class MuiTextFieldModel extends Question {
  getType(): string {
    return TYPE;
  }

  get limitInput() {
    return this.getPropertyValue('limitInput');
  }
  set limitInput(val) {
    this.setPropertyValue('limitInput', val);
  }

  get inputType() {
    return this.getPropertyValue('inputType');
  }
  set inputType(val) {
    this.setPropertyValue('inputType', val);
  }

  get tooltip() {
    return this.getPropertyValue('tooltip');
  }
  set tooltip(val) {
    this.setPropertyValue('tooltip', val);
  }

  get titleForMobile() {
    return this.getPropertyValue('titleForMobile');
  }
  set titleForMobile(val) {
    this.setPropertyValue('titleForMobile', val);
  }
}

export class MuiTextField extends SurveyQuestionElementBase {
  inputRef = React.createRef<HTMLDivElement>();

  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    this.question.questionRef = this.inputRef;
  }

  get question() {
    return this.questionBase;
  }

  get limitInput() {
    return this.question.limitInput;
  }

  handleChange({ target: { value } }: React.ChangeEvent<HTMLInputElement>) {
    const { inputType } = this.question;
    if (this.limitInput && !new RegExp(this.limitInput).test(value)) {
      return;
    }
    this.question.value = inputType === 'number' && value ? parseInt(value) : value;
  }

  handleBlur({ target: { value } }: React.FocusEvent<HTMLInputElement>) {
    this.question.value = value ? value.replace(/\s+/g, ' ').trim() : value;
  }

  protected renderElement(): JSX.Element | null {
    const model = this.question.survey as Model;
    const { value, title, isRequired, errors, tooltip, readOnly, titleForMobile } = this.question;
    const { packageType } = model.data;
    const tooltipText = get(tooltip, packageType, tooltip);

    return (
      <Box display="flex" alignItems="center">
        <ResponsiveTextField
          ref={this.inputRef as RefObject<any>}
          label={title}
          labelForMobile={titleForMobile}
          value={!value && value !== 0 ? '' : value}
          inputProps={{ tabIndex: 1 }}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          required={isRequired}
          color="primary"
          variant="outlined"
          error={errors.length > 0}
          helperText={errors[0] ? errors[0].locText.text : ''}
          disabled={readOnly}
          fullWidth
        />
        {tooltipText && <InfoTooltip tooltip={tooltipText} />}
      </Box>
    );
  }
}
